import axios from 'axios';
import _     from "lodash";
import React, {Fragment,Component} from 'react';
import {Container, Breadcrumb, Message, Form, Table, Tab} from 'semantic-ui-react';
import {Label, Header} from 'semantic-ui-react';
import {Image, Divider, Progress,Icon,Modal,Dimmer, Loader, Grid, Segment, Item, Popup, Button, Card} from 'semantic-ui-react';
import { Link } from 'react-router-dom'
import Panel from '../../components/Panel';
import Client from './Client';
import Iframe from "react-iframe"

class CloudPing extends Component {
    render() {
      return (
        <div>
          <p>Ping various IDCs around the world from your device, you can compare speeds by toggling the proxy.</p>
          <Iframe url="https://webping.cloud/"
            className="myClassname"
            width="100%"
            height="1200px"
            frameBorder="0"
            display="initial"
            position="relative"/>
        </div>
      )
    }
}

class Monitor extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            loading:true,
            code: '',
            codeError: false,
            msg: '',
            msgType:'',
            loading: false,
        };
    }

    componentDidMount(){
      window.scrollTo(0, 0);
      setTimeout(()=>{
        this.setState({loading:false})
      },10000)
    }

    render() {

        return (
          <Fragment>
            <Breadcrumb>
              <Breadcrumb.Section link>
                <Link to="/console">Home</Link>
              </Breadcrumb.Section>
              <Breadcrumb.Divider />
              <Breadcrumb.Section active>Speedtest</Breadcrumb.Section>
            </Breadcrumb>
            <Container style={{marginTop:"30px"}}>

              <Tab panes={[
                { menuItem: 'Cloudflare Speed Test', render: () => <Tab.Pane loading={this.state.loading}>
                        <p>Test your connection with Cloudflare Servers</p>
                        <a href="https://speed.cloudflare.com" target="_blank">
                        <Button color="green">
                          Go to Cloudflare
                        </Button>
                        </a>
                  </Tab.Pane> },
                { menuItem: 'Youtube.com Test', render: () => <Tab.Pane>

                        <p>After activating Proxy, test the speed of Youtube. You can right-click the video and select 'stats for nerds'. If it's above 2000 Kbps, the video can smoothly play high-quality videos.</p>
                        <p>We do not recommend you to watch videos higher than 4K (4096p x 2160p), because 4K+ videos consume data very quickly, at a rate of about 10-20GB per hour.</p>

                        <Iframe url="https://www.youtube.com/embed/F-wBgsf8jWY"
                          url2="https://www.youtube.com/embed/txWmd7QKFe8"
                          url3="https://www.youtube.com/embed/pvck6LiHk1A?start=142"
                          allowfullscreen
                          className="myClassname"
                          width="100%"
                          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
                          height="500px"
                          frameBorder="0"
                          display="initial"
                          position="relative"/>

                  </Tab.Pane> },

                { menuItem: 'Netflix Speed Test', render: () => <Tab.Pane loading={this.state.loading}>

                        <p>You can test your connection speed with the Netflix (US) server here.</p>
                        <p>Fast.com is developed by Netflix and uses Netflix's own network as a test result.</p>
                        <p>Compared to Speedtest and speed testing software, Fast.com's data is slower because most Fast.com servers are located in the United States.</p>
                        <p>If you are mainly concerned about video speeds, we recommend you refer to the actual usage speed of watching videos on Youtube.com.</p>

                        <Iframe url="https://fast.com"
                          className="myClassname"
                          width="100%"
                          height="800px"
                          frameBorder="0"
                          display="initial"
                          position="relative"/>
                  </Tab.Pane> },

                { menuItem: 'Cloud Ping', render: () => <Tab.Pane>
                        <CloudPing/>
                  </Tab.Pane> }
              ]} />

            </Container>
          </Fragment>
        )
    }
}

class Servers extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            snapshots: [],
            events:[],
            status: 'OK',
        };
        this.fetchServerSnapshots = this.fetchServerSnapshots.bind(this);
        this.renderBodyRow        = this.renderBodyRow.bind(this);
    }

    componentDidMount() {
        this.fetchServerSnapshots();
    }

    renderBodyRow(data, index) {

        if(data.detail.type == "benchmark"){
          return this.renderSpeedtest(data,index)
        }

        if(data.detail.type == "benchmark-fast"){
          return this.renderSpeedtest(data,index)
        }

        if(data.detail.type == "benchmark-cloudflare"){
          return this.renderCloudflare(data,index)
        }

    }

    renderCloudflare(message) {

      var data = message.detail;
      var date = new Date(data.time).toLocaleString().split(",")[0];
      var time = new Date(data.time).toLocaleString().split(",")[1];
      return {
        key: data.time,
        cells: [{
          content: (<div >
            <h1>Speed.cloudflare.com (Local Speed)</h1>
            <p>Time: { date }  { time }</p>
            <p>Product: {data.data.monitor.split("-")[3]} </p>
            <p>ISP: {data.data.city} {data.data.isp} {data.data.bandwidth} Bandwidth</p>
            {data.data.proxy?<p>Proxy(Auto): {data.data.proxy.now} </p>:null}
            <p><a href="https://speed.cloudflare.com">Test by Cloudflare.com</a></p>
          </div>)
        },{
          content: (
          <div>
            <Image size='large' src={`https://benchmark-screenshot.s3-ap-northeast-1.amazonaws.com/${data.data.image}`} />
          </div>
          )
        }]
      }

    }

    renderSpeedtest(message) {

      var data = message.detail;
      var date = new Date(data.time).toLocaleString().split(",")[0];
      var time = new Date(data.time).toLocaleString().split(",")[1];
      return {
        key: data.time,
        cells: [{
          content: (<div>
            <h1>Fast.com (North American Speed)</h1>
            <p>Time: { date }  { time }</p>
            <p>Product: {data.data.monitor.split("-")[3]} </p>
            <p>ISP: {data.data.city} {data.data.isp} {data.data.bandwidth} Bandwidth</p>
            {data.data.proxy?<p>Proxy(Auto): {data.data.proxy.now} </p>:null}
            <p><a href="https://fast.com">Test by Fast.com</a></p>
          </div>)
        },{
          content: (
          <div>
            <Image size='large' src={`https://benchmark-screenshot.s3-ap-northeast-1.amazonaws.com/${data.data.image}`} />
          </div>
          )
        }]
      }

    }

    fetchServerSnapshots() {
        axios.get('/server/snapshots').then(({data}) => {

            const {code, data: server} = data;
            if (code === 0) {

                server.snapshots = server.snapshots.map(i=>{
                  return i;
                }).filter((i)=>{
                  return i.business == "snapshot-5"
                }).filter((i)=>{
                  return i.detail.data.monitor.indexOf("Monitor") == -1;
                });

                this.setState({
                    snapshots: server.snapshots,
                });

            }

        });
    }

    headers(){
      return {
        cells: ["测速点结果",""]
      }
    }

    render() {

        return (
            <div>

                <p>以下是联通(100Mbps)速点数据, 通过<a href="https://fast.com"> Fast.com </a>收集速度结果.</p>

                <Header color='green' dividing attached='top'>
                    GLaDOS Speed Test Events
                </Header>

                <Table
                    attached
                    unstackable
                    padded
                    color='green'
                    headerRow={this.headers()}
                    renderBodyRow={this.renderBodyRow}
                    tableData={this.state.snapshots}
                />

            </div>
        );
    }
}

export default Monitor;
